import fa from './langs/fa'
import en from './langs/en'

export default { fa, en }
export { fa, en }

